import { TableBody, Tooltip } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import {
  withStyles,
  Theme,
  createStyles,
  darken
} from '@material-ui/core/styles'

import NoDataImage from '../../../assets/images/No-Data.png'
import { getTranslate } from '../../../localization'
import { Booking, BookingDetails } from '../../../types/booking'
import { BookingsListTableRowMobile } from './BookingsListTableRowMobile'
import { BookingsListTableRowMobileSkeleton } from './BookingsListTableRowMobile.skeleton'

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.2)
          : '#a5a5a5',
      color: theme.palette.common.white
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

interface BookingsListTableMobileProps {
  data: Booking | undefined
  loadingForGetBookingList: boolean
  hasAccessToViewBookingDetails: boolean | undefined
  hasAccessToEditBookingDetails: boolean | undefined
}
export const BookingsListTableMobile: React.FC<
  BookingsListTableMobileProps
> = ({
  data,
  loadingForGetBookingList,
  hasAccessToViewBookingDetails,
  hasAccessToEditBookingDetails
}) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left">
              <Tooltip
                placement="top"
                title={getTranslate('Reservation Number')}>
                <div>{getTranslate('R.N')}</div>
              </Tooltip>
            </StyledTableCell>
            <StyledTableCell align="left">
              <Tooltip placement="top" title={getTranslate('Booker Name')}>
                <div>{getTranslate('B.Name')}</div>
              </Tooltip>
            </StyledTableCell>
            <StyledTableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {loadingForGetBookingList ? (
            Array(6)
              .fill('')
              .map((item, index) => (
                <BookingsListTableRowMobileSkeleton
                  key={`accommodation-skeleton${item}${index.toString()}`}
                />
              ))
          ) : data && data.bookingsList.length > 0 ? (
            data?.bookingsList.map((singleBooking: BookingDetails) => (
              <BookingsListTableRowMobile
                hasAccessToViewBookingDetails={hasAccessToViewBookingDetails}
                hasAccessToEditBookingDetails={hasAccessToEditBookingDetails}
                data={singleBooking}
                key={singleBooking.bookingNumber}
              />
            ))
          ) : (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) scale(.8)'
              }}>
              <img src={NoDataImage} alt="" />
            </div>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
